import { computed, observable } from "mobx";

class Job {
  @observable jobId;

  @observable status;

  @computed
  get isRunning() {
    return ![Job.STATUS.COMPLETED, Job.STATUS.FAILED].includes(this.status);
  }

  constructor({ jobId, status }) {
    this.jobId = jobId;
    this.status = status;
  }
}
Job.STATUS = {
  UNQUEUED: "unqueued",
  QUEUED: "queued",
  RUNNING: "running",
  WAIT_ASYNC: "wait_async",
  COMPLETED: "completed",
  FAILED: "failed",
};
Job.STATUS_DESCRIPTION = {
  unqueued: "Not in queue",
  queued: "In queue",
  running: "Job is running",
  wait_async: "Job is running",
  completed: "Completed",
  failed: "Error",
};
export default Job;
